import InfoSharpIcon from '@mui/icons-material/InfoSharp'
import { useHistory, useLocation } from 'react-router-dom'

import { themeClubbi, useMediaQuery } from 'clubbi-ui'
import { useAppDispatch, useAppSelector } from '../../common/hooks'
import { cartActions } from '../../store/slices/cart'
import { scheduledDeliveryActions } from '../../store/slices/scheduleDelivery'
import { sessionActions } from '../../store/slices/session'
import { shippingInfosActions } from '../../store/slices/ShippingInfos'
import {
  ButtonSpinner,
  StyledActions,
  StyledContent,
  StyledDescription,
  StyledErrorMessage,
  StyledHeader,
  StyledImage,
  StyledModal,
  StyledPrimaryButton,
  StyledSecondaryButton,
  StyledTitle,
  StyledWarningIconWrapper,
  StyledWarningText,
  StyledWarningWrapper,
  StyledWrapper,
} from './styles/MigrationAbasteceShopModal.style'
import { MIGRATION_REQUIRED_MERCHANT_CODES, URLS_ABASTECE_SHOP } from '../../common/constants'
import { redirectToAbasteceShopWithSso } from '../../common/abasteceShopSso'
import { useState } from 'react'

const notOpenModalRoutes = [
  '/invoices',
  '/profile',
  '/profile/contacts',
  '/pedidos-em-aberto',
  '/sales-flyer',
  '/redirect-abastece-shop',
  '/purchase',
  '/delivery',
]

export const MigrationAbasteceShopModal = (): JSX.Element => {
  const dispatch = useAppDispatch()
  const history = useHistory()
  const location = useLocation()
  const isDesktop = useMediaQuery(themeClubbi.breakpoints.up('md'))
  const { merchantCode, clubberEmail, hasMigratedToAbasteceshop } = useAppSelector(
    (state) => state.session
  )
  const [isLoading, setIsLoading] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')

  const merchantMigrated =
    Boolean(hasMigratedToAbasteceshop) ||
    MIGRATION_REQUIRED_MERCHANT_CODES.includes(merchantCode ?? '')

  const isOpen =
    Boolean(merchantCode) &&
    merchantMigrated &&
    !notOpenModalRoutes.includes(location.pathname) &&
    !location.pathname.startsWith('/delivery-summary/')
  const hasClubberEmail = Boolean(clubberEmail)

  const primaryButtonLabel = hasClubberEmail ? 'Ir para o Smart Force' : 'Comprar no AbasteceShop'
  const title = 'Sua nova loja está cheia de benefícios'

  const description = (
    <>
      Agora seus pedidos da Clubbi devem ser feitos pelo <strong>AbasteceShop</strong>.
      <br />
      Evoluímos para uma nova loja onde você encontra mais campanhas especiais, promoções e o Shop+
    </>
  )

  const image = isDesktop ? '/img/modal-abastece-desktop.png' : '/img/modal-abastece-mobile.png'

  const handlePrimaryClick = async () => {
    setIsLoading(true)
    if (hasClubberEmail) {
      window.open(URLS_ABASTECE_SHOP.APP_STORE_SMART_FORCE, '_blank', 'noopener,noreferrer')
      return
    }

    const success = await redirectToAbasteceShopWithSso(merchantCode)
    if (!success) {
      setErrorMessage('Não foi possível redirecionar para o AbasteceShop')
    }

    setIsLoading(false)
  }

  const handleInvoicesClick = () => {
    history.push('/invoices')
  }

  const handleSwitchCustomerClick = () => {
    dispatch(sessionActions.clearMerchantData())
    dispatch(cartActions.cleanUp())
    dispatch(shippingInfosActions.reset())
    dispatch(scheduledDeliveryActions.clearScheduledDelivery())
    dispatch(sessionActions.showModal(false))
  }

  return (
    <StyledModal open={isOpen} disableEscapeKeyDown>
      <StyledWrapper>
        <StyledHeader>
          <StyledImage src={image} alt="AbasteceShop" />
        </StyledHeader>
        <StyledContent>
          <StyledTitle>{title}</StyledTitle>
          <StyledDescription>{description}</StyledDescription>
          {!hasClubberEmail && (
            <StyledWarningWrapper>
              <StyledWarningIconWrapper>
                <InfoSharpIcon />
              </StyledWarningIconWrapper>
              <StyledWarningText>
                A loja antiga continua disponível apenas para você consultar entregas anteriores.
              </StyledWarningText>
            </StyledWarningWrapper>
          )}
          {errorMessage && <StyledErrorMessage>{errorMessage}</StyledErrorMessage>}
          <StyledActions>
            <StyledPrimaryButton onClick={handlePrimaryClick}>
              {isLoading ? <ButtonSpinner /> : primaryButtonLabel}
            </StyledPrimaryButton>
            <StyledSecondaryButton onClick={handleInvoicesClick}>
              Ver entregas anteriores
            </StyledSecondaryButton>
            <StyledSecondaryButton onClick={handleSwitchCustomerClick}>
              Entrar com outro código
            </StyledSecondaryButton>
          </StyledActions>
        </StyledContent>
      </StyledWrapper>
    </StyledModal>
  )
}
